var Mock = require('mockjs');
function useMock () {

  Mock.mock(/.*(app.do)/, 'post', function (options) {
    if (JSON.parse(options.body).service === "002007") {
      return Mock.mock({
        code: '000',
        data: {
          result: [
            {
              code: "K",
              name: "股份有限公司",
              typecode: "CorpStructure",
              typename: "企业类型",
            },
            {
              code: "H",
              name: "股份合作企业",
              typecode: "CorpStructure",
              typename: "企业类型",
            },
            {
              code: "G",
              name: "集体企业",
              typecode: "CorpStructure",
              typename: "企业类型",
            },
            {
              code: "F",
              name: "国有企业",
              typecode: "CorpStructure",
              typename: "企业类型",
            },
            {
              code: "A",
              name: "博士及以上",
              typecode: "EducationType",
              typename: "教育程度",
            },
            {
              code: "B",
              name: "硕士",
              typecode: "EducationType",
              typename: "教育程度",
            },
            {
              code: "B",
              name: "水利、环境、公共管理",
              typecode: "EmpType",
              typename: "单位所属行业",
            },
            {
              code: "H",
              name: "批发零售",
              typecode: "EmpType",
              typename: "单位所属行业",
            },
            {
              code: "A",
              name: "自住无按揭",
              typecode: "HouseType",
              typename: "居住状况",
            },
            {
              code: "B",
              name: "自住有按揭",
              typecode: "HouseType",
              typename: "居住状况",
            },
            {
              code: "A",
              name: "未婚",
              typecode: "MaritalStatus",
              typename: "婚姻状况",
            },
            {
              code: "B",
              name: "已婚",
              typecode: "MaritalStatus",
              typename: "婚姻状况",
            },
            {
              code: "C",
              name: "其他",
              typecode: "MaritalStatus",
              typename: "婚姻状况",
            },
            {
              code: "A",
              name: "销售/中介",
              typecode: "OccupationType",
              typename: "职位",
            },
            {
              code: "B",
              name: "公务员",
              typecode: "OccupationType",
              typename: "职位",
            },
            {
              code: "A",
              name: "父亲",
              typecode: "directRelationship",
              typename: "联系人"
            },
            {
              code: "B",
              name: "母亲",
              typecode: "directRelationship",
              typename: "联系人",
            },
            {
              code: "B",
              name: "子女",
              typecode: "directRelationship",
              typename: "联系人",
            },

            {
              code: "A",
              name: "朋友",
              typecode: "Relationship",
              typename: "联系人",
            },
            {
              code: "B",
              name: "同事",
              typecode: "Relationship",
              typename: "联系人",
            },
            {
              code: "A",
              name: "农村",
              typecode: "hjType",
              typename: "户籍状态",
            },
            {
              code: "B",
              name: "城镇",
              typecode: "hjType",
              typename: "户籍状态",
            },
            {
              code: "A",
              name: "是",
              typecode: "isStudent",
              typename: "是否是学生",
            },
            {
              code: "B",
              name: "否",
              typecode: "isStudent",
              typename: "是否是学生",
            },

          ]
        }
      });
    } else {
      return Mock.mock({
        code: "000",
        msg: {
          text: Mock.Random.paragraph(5)
        },
        data: {
          locationCodeList: [
            {
              text: "江西省",
              code: "2002",
              subList: [
                {
                  text: "遵化市",
                  code: "200",
                  subList: [
                    {
                      text: "方洲县",
                      code: "2039"
                    }
                  ]
                }
              ]
            },
            {
              text: "黑龙江省",
              code: "110000",
              subList: [
                {
                  text: "哈尔滨市",
                  code: "110100",
                  subList: [
                    {
                      text: "南岗区",
                      code: "110101"
                    }
                  ]
                },
              ]
            },
            {
              text: "河北省",
              code: "2002",
              subList: [
                {
                  text: "唐山市",
                  code: "200",
                  subList: [
                    {
                      text: "遵化区",
                      code: "2039"
                    }
                  ]
                },
                {
                  text: "石家庄市",
                  code: "200",
                  subList: [
                    {
                      text: "桥西区",
                      code: "2039"
                    }
                  ]
                },
              ]
            },
            {
              text: "陕西省",
              code: "610000",
              subList: [
                {
                  text: "西安市",
                  code: "610100",
                  subList: [
                    {
                      text: "新城区",
                      code: "610102"
                    }
                  ]
                }
              ]
            }
          ]
        }
      });
    }

  });
};


export default {
  install () {
    if (process.env.NODE_ENV === "mock") {
      useMock();
    }
  }
};